import { render, staticRenderFns } from "./ManageClientsEmployee.vue?vue&type=template&id=a22d2994&"
import script from "./ManageClientsEmployee.vue?vue&type=script&lang=js&"
export * from "./ManageClientsEmployee.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports